import { userDisplayName } from "@kontextwerk/control-web-frame/shared/logic/user-presentation"
import type { OrganizationFrame } from "@kontextwerk/control-web-client"
import { filterSelectableOrganizationUsers } from "../../../../../../../_shared/_logic/organization-users"
import type { EmployeeOption } from "../../../../../../../_shared/_logic/calendar-types"

export const employeeColorPalette = [
  "var(--kontext-accent)",
  "#0ea5e9",
  "#f59e0b",
  "#10b981",
  "#ec4899",
  "#a78bfa",
  "#f97316",
]

export const buildEmployeeOptions = ({
  organization,
  allowedEmployeeIds,
}: {
  organization?: OrganizationFrame | null
  allowedEmployeeIds?: string[] | null
}): EmployeeOption[] =>
  filterSelectableOrganizationUsers(organization?.users ?? [], allowedEmployeeIds).map((user) => {
    const label = userDisplayName(user) || "Unbekannt"
    const first = label.split(/\s+/)[0] ?? label

    return { id: user.id, label, shortLabel: first }
  })

export const buildEmployeeColors = (employees: EmployeeOption[]) =>
  Object.fromEntries(
    employees.map((employee, index) => [
      employee.id,
      employeeColorPalette[index % employeeColorPalette.length],
    ]),
  )

export const resolveTargetEmployeeIds = ({
  isMobile,
  selectedEmployee,
  employees,
}: {
  isMobile: boolean
  selectedEmployee: string | string[]
  employees: EmployeeOption[]
}) => {
  if (isMobile) {
    const single = Array.isArray(selectedEmployee) ? selectedEmployee[0] : selectedEmployee

    if (single && employees.some((employee) => employee.id === single)) return [single]

    return employees.map((employee) => employee.id)
  }

  const list = Array.isArray(selectedEmployee)
    ? selectedEmployee
    : selectedEmployee
      ? [selectedEmployee]
      : []
  const explicit = list.filter((id) => employees.some((employee) => employee.id === id))

  if (explicit.length) return explicit

  return employees.map((employee) => employee.id)
}

export const resolveDefaultSelectedEmployee = ({
  currentValue,
  employees,
  userId,
  isMobile,
}: {
  currentValue: string | string[]
  employees: EmployeeOption[]
  userId?: string | null
  isMobile: boolean
}) => {
  if (currentValue && (!Array.isArray(currentValue) || currentValue.length)) return currentValue

  const targetId =
    userId && employees.some((employee) => employee.id === userId)
      ? userId
      : (employees[0]?.id ?? "")

  return isMobile ? targetId : targetId ? [targetId] : []
}
